import React from "react";
import { Truck, Package, Container } from "lucide-react";

/**
 * Sélecteur du sous-type de poids lourd : 3 pills bien distinctes
 * - tracteur_solo : cabine motrice seule
 * - porteur : camion avec caisse/benne fixée
 * - semi_remorque : remorque articulée seule
 */
export const PL_SOUS_TYPES = [
  {
    id: "tracteur_solo",
    label: "Tracteur solo",
    short: "Tracteur",
    description: "Cabine motrice seule",
    icon: Truck,
  },
  {
    id: "porteur",
    label: "Porteur",
    short: "Porteur",
    description: "Caisse/benne fixée",
    icon: Package,
  },
  {
    id: "semi_remorque",
    label: "Semi-remorque",
    short: "Semi-rem.",
    description: "Remorque articulée",
    icon: Container,
  },
];

export const getPlSousTypeLabel = (id) =>
  PL_SOUS_TYPES.find((t) => t.id === id)?.label || null;

export const PlSousTypeSelector = ({ value, onChange }) => {
  return (
    <div
      data-testid="pl-soustype-selector"
      className="mt-5 w-full"
      role="radiogroup"
      aria-label="Sous-type de poids lourd"
    >
      <div className="mb-3 text-center">
        <span className="font-mono text-[10px] uppercase tracking-widest text-indigo-300">
          Préciser le type de poids lourd
        </span>
      </div>
      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        {PL_SOUS_TYPES.map((t) => {
          const Icon = t.icon;
          const active = value === t.id;
          return (
            <button
              key={t.id}
              type="button"
              role="radio"
              aria-checked={active}
              data-testid={`pl-soustype-${t.id}`}
              onClick={() => onChange(active ? null : t.id)}
              className={`group relative flex flex-col items-center gap-1.5 overflow-hidden rounded-xl border bg-slate-900/60 px-2 py-3 text-center transition-all duration-200 hover:-translate-y-0.5 ${
                active
                  ? "border-indigo-400 bg-indigo-500/15 shadow-[0_0_20px_rgba(129,140,248,0.3)]"
                  : "border-slate-800 hover:border-slate-700"
              }`}
            >
              <Icon
                className={`h-5 w-5 ${
                  active ? "text-indigo-300" : "text-slate-400 group-hover:text-slate-200"
                }`}
                strokeWidth={1.8}
              />
              <div
                className={`font-heading text-xs font-bold uppercase tracking-wide sm:text-sm ${
                  active ? "text-slate-50" : "text-slate-200"
                }`}
              >
                <span className="hidden sm:inline">{t.label}</span>
                <span className="sm:hidden">{t.short}</span>
              </div>
              <div className="hidden text-[10px] text-slate-500 sm:block">
                {t.description}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
